<div class="flex w-full">
  @if (!collapsed()) {
    <div class="px-6 border-l-4 border-transparent" [class.border-primary]="active()"></div>
  }
  <button
    [attr.data-active]="active()"
    [attr.data-collapsed]="collapsed()"
    class="transition-colors duration-150 flex-1 text-left hover:bg-base-200"
    [class.px-1]="!collapsed()"
    [class.px-3]="collapsed()"
    [class.py-1.5]="collapsed()"
    [class.bg-primary/10]="active()"
    [class.text-primary!]="active()">
    <ng-content />
  </button>
</div>
